import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-mobile-container',
  templateUrl: './mobile-container.component.html',
  styleUrls: ['./mobile-container.component.scss'],
  encapsulation : ViewEncapsulation.None,
})
export class MobileContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
